module.exports = __webpack_public_path__ + "static/media/success-tick.f62dd6fe.png";